<template>
  <div>
    <span id="topo"></span>

    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn text rounded color="primary" :disabled="salvando || finalizando" @click="cancelar">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      <!-- </v-toolbar-items> -->
      <!-- <v-spacer></v-spacer> -->

      
      <template v-slot:actions v-if="pedido.id">
        <!-- <v-btn text :disabled="salvando || finalizando" @click="cancelar">Cancelar</v-btn> -->
        <v-btn
          v-if="!visualizando"
          text
          rounded
          color="primary"
          :disabled="salvando"
          :loading="salvando"
          @click="salvarSair"
        >Salvar e Sair</v-btn>
        <v-btn
          v-if="!visualizando"
          depressed
          rounded
          color="primary"
          :disabled="finalizando"
          :loading="salvando"
          @click="salvarFinalizarPedido"
        >Finalizar Pedido</v-btn>
        <!-- <v-btn
          v-if="!visualizando"
          text
          rounded
          color="primary"
          :disabled="finalizando"
          :loading="salvando"
          @click="confirmar"
        >Salvar Pedido</v-btn>
        <v-divider 
          vertical 
          class="mx-4"
          v-if="!visualizando && !copiando"
        ></v-divider>
        <v-btn
          v-if="!visualizando && !copiando"
          depressed
          rounded
          color="primary"
          :disabled="salvando || !podeFinalizar"
          :loading="finalizando"
          @click="finalizar"
        >{{ texto_botao }}</v-btn> -->
      </template>
    </z-centralized-toolbar>

    <z-loading :message="message_pedido" :loading="loading_pedido">

      <v-form ref="form" v-model="form_valido" lazy-validation>
        <z-container>
          <!-- <h3 class="headline mb-3">{{ titulo }} Pedido</h3> -->

          <v-card class="mb-3" :class="{sticky: visualizando}">
            <v-toolbar flat color="white" dense>
              <span class="text-subtitle-2">Dados do Pedido</span>
            </v-toolbar>

            <v-divider></v-divider>

            <v-card-text class="text--primary">
              <v-row dense>
                <v-col col="12" sm="2">
                  <v-text-field
                    label="Número"
                    v-model="pedido.id"
                    disabled
                    filled
                    dense
                  ></v-text-field>
                </v-col>
                <v-col col="12" sm="2">
                  <!-- <v-text-field label="Data" v-model="pedido.data" append-icon="event"></v-text-field> -->
                  <z-date-picker-menu
                    label="Data"
                    v-model="pedido.data"
                    :disabled="$auth.cant('pedidos:alterar_data') || !config.APP_ALTERAR_DATA_VENDA"
                    :readonly="$auth.cant('pedidos:alterar_data') || !config.APP_ALTERAR_DATA_VENDA"
                    filled
                    dense
                  ></z-date-picker-menu>
                </v-col>
                <v-col col="12" sm="8">
                  <v-autocomplete
                    v-model="pedido.cliente_id"
                    :rules="regras.cliente"
                    label="Cliente"
                    flat
                    :items="clientes_lista"
                    filled
                    dense
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col col="12" sm="3" xl="3">
                  <v-select
                    v-model="pedido.forma_pagamento"
                    label="Forma de Pagamento"
                    :items="$globals.FORMAS_DE_PAGAMENTO"
                    filled
                    dense
                  ></v-select>
                </v-col>
                <!-- <v-col col="12" sm="2">
                  <v-select v-model="pedido.prazo_id" label="Prazo de Pagamento" :items="$globals.PRAZOS_DE_PAGAMENTO"></v-select>
                </v-col> -->
                <v-col col="12" sm="3">
                  <v-select
                    v-model="pedido.vendedor_id"
                    label="Vendedor"
                    filled
                    dense
                    :rules="regras.vendedor"
                    :items="$store.getters['listas/vendedores']"
                  ></v-select>
                </v-col>
                <v-col col="12" sm="6">
                  <v-text-field
                    label="Prazo"
                    :value="prazo_cliente"
                    suffix="dias"
                    readonly
                    filled
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <template v-if="!pedido.id">
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="salvando" @click="cancelar">
                  Cancelar
                </v-btn>
                <v-btn
                  depressed
                  color="primary"
                  :loading="salvando"
                  @click="iniciarPedido"
                >Iniciar Pedido</v-btn>
              </v-card-actions>
            </template>
          </v-card>

          <template v-if="pedido.id">
            <adicionar-produto 
              v-if="!visualizando"
              class="mb-3 sticky" 
              ref="adicionarProduto"
              :pedido="pedido"
              :produtos="pedido.produtos"
              :permitir-produtos-duplicados="config.PERMITIR_PRODUTOS_DUPLICADOS"
              :somar-produtos="config.SOMAR_PRODUTOS_PEDIDO"
              :alterar-preco="config.ALTERAR_PRECO_NO_PEDIDO"
              :adicionando="adicionando"
              :total="pedido.valor_liquido"
            ></adicionar-produto>

            <v-card class="mb-3 sticky" v-if="false">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Adicionar Produto</h3>
                <v-spacer></v-spacer>
                <span class="mr-5">Itens: {{ produtos.length }}</span>
                <span class="mr-5">Valor Total: {{ pedido.valor_liquido | valorBR }}</span>
              </v-toolbar>

              <v-divider></v-divider>

              <v-card-text>
                <v-row dense>
                  <v-col cols="2" sm="2">
                    <v-text-field
                      v-model="produto.referencia"
                      append-icon="search"
                      ref="referencia"
                      label="Referência"
                      placeholder=" "
                      autofocus
                      filled
                      dense
                      :loading="buscando"
                      :hide-details="hidedetails"
                      :disabled="buscando"
                      @keyup.enter="buscarProdutoPorReferencia"
                      @keyup.esc="onKeyUpEscAdicionarProduto"
                      @click:append="buscarProduto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" sm="4">
                    <v-text-field
                      v-model="produto.descricao"
                      ref="descricao"
                      label="Descrição"
                      readonly
                      filled
                      dense
                      :hide-details="hidedetails"
                      :disabled="buscando"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="2">
                    <z-campo-valor
                      v-model="produto.quantidade"
                      ref="quantidade"
                      label="Quantidade"
                      persistent-hint
                      append-icon="mdi-view-list"
                      filled
                      dense
                      :label="labelQuantidade"
                      :hide-details="hidedetails"
                      :decimais="config.CASAS_DECIMAIS_QUANTIDADE"
                      :hint="`Estoque: ${produto.estoque} (F2 - Exibir)`"
                      :disabled="buscando || !produto.descricao"
                      @keyup.enter="$refs.valor.focus()"
                      @keyup.esc="onKeyUpEscAdicionarProduto"
                      @input="calcularSubTotal"
                      @click:append="exibirEntradas(produto)"
                      @keyup.f2="exibirEntradas(produto)"
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="2" sm="2">
                    <z-campo-valor
                      v-model="produto.valor"
                      append-icon="mdi-send"
                      ref="valor"
                      label="Valor"
                      filled
                      dense
                      :loading="adicionando"
                      :hide-details="hidedetails"
                      :disabled="buscando || !produto.descricao || adicionando"
                      :readonly="!config.ALTERAR_PRECO_NO_PEDIDO"
                      @click:append="adicionarProduto"
                      @keyup.enter="adicionarProduto"
                      @keyup.esc="onKeyUpEscAdicionarProduto"
                      @input="calcularSubTotal"
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="2" sm="2">
                    <z-campo-valor
                      v-model="produto.subtotal"
                      ref="subtotal"
                      label="SubTotal"
                      filled
                      dense
                      readonly
                      :hide-details="hidedetails"
                      :disabled="buscando || !produto.descricao"
                    ></z-campo-valor>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-3">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Produtos</h3>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-divider></v-divider>

              <v-data-table
                :headers="headers"
                :items="produtos"
                hide-default-footer
                disable-pagination
                item-key="id"
                :loading="false"
              >
                <template v-slot:item="{ item: produto, index: index_produto }">
                  <tr :class="{ novo: produto.novo }">
                    <td>{{ index_produto + 1 }}</td>
                    <td>{{ produto.referencia }}</td>
                    <td>
                      <div>{{ produto.descricao }}</div>
                      <template v-if="produto.grade">
                        <v-chip
                          v-for="(_grade, index) in produto.grade"
                          class="mr-2"
                          x-small 
                          color="grey lighten-2"
                          :key="index"
                        >{{_grade.descricao}}</v-chip>
                      </template>
                    </td>
                    <td class="text-right">
                      <v-chip
                        v-if="produto.estoque_insuficiente"
                        color="red"
                        small
                        class="white--text"
                      >Estoque: {{ produto.estoque_atual }}</v-chip>
                      {{ produto.quantidade | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }} {{ produto.unidade }}
                    </td>
                    <td class="text-right">{{ produto.valor | valorBR }}</td>
                    <td class="text-right">{{ produto.subtotal | valorBR }}</td>
                    <td class="text-center">
                      <v-btn
                        icon
                        :disabled="visualizando && !copiando"
                        @click="excluirProduto(produto, index_produto)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
                <template v-slot:body.append="{ headers }">
                  <tr>
                    <td class="text-right" colspan="4">
                      <b>{{ pedido.quantidade_total | valorQTD(config.CASAS_DECIMAIS_QUANTIDADE) }}</b>
                    </td>
                    <td class="text-right" colspan="2">
                      <b>{{ pedido.valor_bruto | valorBR }}</b>
                    </td>
                    <td></td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>

            <v-card class="mb-3">
              <v-toolbar flat color="white" dense>
                <h3 class="text-subtitle-2">Totais</h3>
              </v-toolbar>

              <v-divider></v-divider>

              <v-card-text class="text--primary">
                <v-row dense>
                  <v-col cols="12" sm="2">
                    <z-campo-valor
                      v-model="pedido.quantidade_total"
                      label="Total Qtd."
                      readonly
                      filled
                      dense
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <z-campo-valor
                      v-model="pedido.valor_bruto"
                      label="Total Bruto"
                      readonly
                      filled
                      dense
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <v-select
                      v-model="pedido.tipo_desconto"
                      label="Tipo Desconto"
                      filled
                      dense
                      :items="['R$', '%']"
                      @change="calcularTotais"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <z-campo-valor
                      v-model="pedido.desconto_valor"
                      label="Valor Desconto"
                      filled
                      dense
                      @input="calcularTotais"
                    ></z-campo-valor>
                  </v-col>
                  <v-col cols="12" sm="2">
                    <z-campo-valor
                      v-model="pedido.valor_liquido"
                      label="Total Líquido"
                      readonly
                      filled
                      dense
                    ></z-campo-valor>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="pedido.observacoes"
                      label="Observações"
                      rows="3"
                      filled
                      dense
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

          </template>
        </z-container>
      </v-form>

    </z-loading>


    <!-- <busca-produto ref="buscaproduto" @selecionar:produto="selecionarProduto"></busca-produto> -->
    <dialogo-buscar-produto
      ref="buscaproduto"
      @selecionar:produto="selecionarProduto"
    ></dialogo-buscar-produto>

    <z-dialogo
      ref="dialogoEstornar"
      titulo="Deseja estornar esse pedido?"
      :dividers="true"
      largura="500px"
    >
      <v-container fluid slot="texto">
        <h3>
          Todas faturas lançadas para esse pedido serão removidas.<br />
          O pedido voltará a ser um Orçamento.<br />
          Deseja realmente estornar esse pedido?
        </h3>
      </v-container>

      <v-btn text @click="$refs.dialogoEstornar.fechar()" :disabled="estornando">Cancelar</v-btn>
      <v-btn
        color="red darken-1"
        text
        :loading="estornando"
        :disabled="estornando"
        @click="confirmarEstornar"
      >Estornar</v-btn>
    </z-dialogo>

    <z-dialogo-sim-nao
      ref="dialogoRecuperarPedido"
      titulo="Recuperar pedido?"
      botaoSim="Recuperar"
      botaoNao="Dispensar"
    >
      Um pedido não foi finalizado. Deseja recuperar-lo?
    </z-dialogo-sim-nao>

    <z-dialogo-sim-nao
      ref="dialogoSalvarPedido"
      titulo="Salvar pedido?"
      botaoSim="Salvar e Sair"
      botaoNao="Sair sem Salvar"
      botaoCancelar
      largura="500px"
    >
      As alterações no pedido não foram salvas. Deseja salvar?
    </z-dialogo-sim-nao>

    <z-dialogo-sim-nao
      ref="dialogoRemoverItem"
      titulo="Remover item?"
      botaoSim="Remover"
      botaoNao="Não Remover"
    >
      O item será removido do pedido. Deseja remover?
    </z-dialogo-sim-nao>

    <z-dialogo-sim-nao
      ref="dialogoImprimirSalvar"
      titulo="Finalizar pedido?"
      botaoSim="Finalizar e Imprimir"
      botaoNao="Cancelar"
      botaoCancelar_
      largura="500px"
    >
      O pedido será finalizado e impresso. Deseja finalizar?
    </z-dialogo-sim-nao>

    <faturamento ref="faturamento" @faturado="faturado"></faturamento>

    <dialogo-exibir-entradas ref="dialogoExibirEntradas"></dialogo-exibir-entradas>

  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import BuscaProduto from "./BuscaProduto";
import DialogoBuscarProduto from "./DialogoBuscarProduto";
import { createLocalStorage } from "@/app/utils/LocalStorage";
import config from "@/app/config";
// import { STATUS_PRODUTO } from "@/app/globals";
import { trunc } from "@/app/helpers/conversoes";

import Faturamento from "./Faturamento";
import DialogoExibirEntradas from "@/pages/produtos/DialogoExibirEntradas";
import AdicionarProduto from "@/pages/produtos/AdicionarProduto";

const storage = createLocalStorage(config);

export default {
  name: "pedidos-form",

  components: {
    BuscaProduto,
    DialogoBuscarProduto,
    Faturamento,
    DialogoExibirEntradas,
    AdicionarProduto,
  },

  data() {
    return {
      conf: config,
      pedido: {
        cliente_id: null,
        data: this.hoje(),
        itens: 0,
        quantidade_total: 0,
        frete: 0,
        taxa_valor: 0,
        desconto_valor: 0,
        tipo_desconto: "R$",
        valor_bruto: 0,
        valor_liquido: 0,
        forma_pagamento: "",
        observacoes: "",
        produtos: [],
      },
      produto: {
        referencia: null,
        descricao: null,
        unidade: null,
        quantidade: 0,
        valor: 0,
        subtotal: 0,
        estoque: 0,
      },
      parcelas: [],
      forma_pagamento: "Duplicata",
      numero_parcelas: 1,
      prazo: 30,
      tipo_desconto: "R$",
      select: 1,
      salvando: false,
      finalizando: false,
      buscando: false,
      estornando: false,
      regras: {
        cliente: [(v) => !!v || "O campo cliente é obrigatório"],
        vendedor: [(v) => !!v || "O campo vendedor é obrigatório"],
      },
      form_valido: false,
      tab: "",
      headers: [ 
        { text: "Item", value: "", sortable: false, },
        { text: "Referência", value: "referencia", width: "150px", sortable: false, },
        { text: "Descrição", value: "descricao", sortable: false },
        { text: "Quantidade", value: "quantidade", align: "right", sortable: false, },
        { text: "Valor", value: "valor", align: "right", sortable: false },
        { text: "SubTotal", value: "subtotal", align: "right", sortable: false, },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false, },
      ],
      headers_faturamento: [
        { text: "Forma de Pagamento", value: "forma_pagamento", width: "120px", sortable: false, },
        { text: "Vencimento", value: "vencimento", align: "center", sortable: false, },
        { text: "Valor", value: "valor", align: "right", sortable: false },
        { text: "Opções", value: "", width: "200px", align: "center", sortable: false, },
      ],
      loading: false,
      drawerProdutos: false,
      buscarproduto: "",
      produtosBusca: [],
      exibirMensagem: false,
      hidedetails: false,
      pedido_alterado: false,
      inicio: true,
      alteracoes: 0,
      adicionando: false,
      exibindoEntradas: false,
      loading_pedido: false,
      message_pedido: "Carregrando tela de Pedido. Aguarde..."
    };
  },

  computed: {
    ...mapGetters("listas", {
      clientes_lista: "clientes",
    }),

    produtos() {
      return this.pedido.produtos.filter(produto => produto.status != this.$globals.STATUS_PRODUTO.DELETED);
    },

    labelQuantidade() {
      return this.produto.unidade ? "Quantidade (" + this.produto.unidade + ")" : "Quantidade";
    },

    prazo_cliente() {
      if (this.pedido.cliente_id) {
        let cliente = this.$store.state.listas.clientes.find(
          (cliente) => cliente.id === this.pedido.cliente_id
        );
        if (cliente) {
          return cliente.prazo;
        }
      }

      return "";
    },

    totalBruto() {
      return this.produtos.reduce((soma, produto) => soma + produto.valor, 0);
    },

    totalLiquido() {
      return this.totalBruto - Number(this.pedido.taxa_valor);
    },

    totalParcelas() {
      return this.parcelas.reduce(
        (soma, parcela) => soma + Number(parcela.valor),
        0
      );
    },

    saldo() {
      return trunc(this.pedido.valor_liquido - this.totalParcelas);
    },

    config() {
      return this.$store.state.configuracoes;
    },

    visualizando() {
      return (
        (this.pedido.situacao == "Faturado" || this.pedido.situacao == "Cancelado") && !this.$route.meta.copiando
      );
    },

    copiando() {
      return this.$route.meta.copiando ? true : false;
    },

    titulo() {
      let titulo;
      if (this.$route.meta.copiando) {
        titulo = "Copiando";
      } else if (this.$route.meta.editando) {
        titulo = !this.visualizando ? "Editar" : "Visualizando";
      } else {
        titulo = "Adicionar";
      }
      return titulo + " " + "Pedido";
    },

    texto_botao() {
      return this.$route.meta.copiando ? "Copiar" : "Finalizar Pedido";
    },

    podeFinalizar() {
      return this.produtos.length > 0;
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$route.meta.editando || vm.$route.meta.copiando) {
        console.log("Editando ou Copiando...");
      } else {
        console.log("Adicionando...");
      }
    });
  },

  async beforeRouteLeave(to, from, next) {
    if (this.alteracoes > 1) {
      let response = await this.$refs.dialogoSalvarPedido.abrir();

      if (response == null) {
        return;
      }

      if (response == true) {
        if (!this.$refs.form.validate()) return;
        // if (!this.validarProdutos()) return;

        this.confirmar();
        next();
      }
    }

    if (this.$route.meta.editando) {
      storage.remove("pedido");
    }

    localStorage.removeItem("copiando");
    this.UNSET_PEDIDO();
    next();
  },

  // async beforeMount() {
    // await this.$store.dispatch("carregarConfiguracoes");
    // await this.$store.dispatch("listas/clientes");
    // await this.$store.dispatch("listas/vendedores");
  // },

  async mounted() {
    this.setTitulo(this.titulo);
    this.loading_pedido = true;
    await this.$store.dispatch("carregarConfiguracoes");
    await this.$store.dispatch("listas/clientes");
    await this.$store.dispatch("listas/vendedores");

    if (this.$route.name == "PedidosEditar") {
      this.abrirPedido(this.$route.params.id);
    } else {
      this.resetPedido();
    }

    this.loading_pedido = false;

  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapMutations("pedidos", ["UNSET_PEDIDO"]),
    ...mapActions("pedidos", [
      "abrir",
      "atualizar",
      "salvar",
      "finalizarPedido",
      "atualizarestoque",
      "adicionaritem",
      "removeritem",
      "copiarPedido",
    ]),

    resetPedido() {
      const pedido = {
        cliente_id: this.config.CLIENTE_PADRAO,
        data: this.hoje(),
        itens: 0,
        quantidade_total: 0,
        frete: 0,
        taxa_valor: 0,
        desconto_valor: 0,
        tipo_desconto: "R$",
        valor_bruto: 0,
        valor_liquido: 0,
        forma_pagamento: this.config.FORMA_PAGAMENTO_PADRAO,
        observacoes: "",
        vendedor_id: this.$auth.getUser().vendedor ? this.$auth.getUser().vendedor.id : null,
        produtos: [],
      };

      this.pedido = { ...pedido };
    },

    async abrirPedido(pedido_id) {
      if (!this.$store.state.pedidos.pedido) {
        try {
          await this.abrir(pedido_id);
          // this.pedido = this.clone(this.$store.state.pedidos.pedido);
        } catch (error) {
          this.$eventbus.erro("Não foi possível abrir este pedido.", error);
          this.$router.push({ name: "PedidosLista" });
        } finally {
          this.LOADING_OFF();
        }
      }

      this.pedido = this.clone(this.$store.state.pedidos.pedido);
      this.processarStatusProdutos(this.pedido.produtos);
    },

    processarStatusProdutos(produtos) {
      produtos.forEach((produto, index) => {
        if (produto.status == this.$globals.STATUS_PRODUTO.DELETED) {
          produtos.splice(index, 1);
        }
        this.$set(produto, "status", this.$globals.STATUS_PRODUTO.UNCHANGED);
      });
    },

    async iniciarPedido() {
      if (this.$refs.form.validate()) {
        // if (!this.validarProdutos()) return;

        try {
          this.salvando = true;

          await this.salvar(this.pedido);
          this.pedido = this.clone(this.$store.state.pedidos.pedido);

          this.$eventbus.notificar("Pedido iniciado com sucesso");

          this.alteracoes = 0;
          storage.remove("pedido");

          this.$router.push({
            name: "PedidosEditar",
            params: { id: this.pedido.id },
          });

        } catch (error) {
          this.$eventbus.erro("Não foi possível iniciar este Pedido. Verifique os dados do pedido e tente novamente.",error);
        } finally {
          this.salvando = false;
        }
      } else {
        this.$vuetify.goTo("#topo", { offset: -100 });
      }
    },

    async confirmar() {
      if (this.$refs.form.validate()) {
        // if (!this.validarProdutos()) return;

        try {
          this.salvando = true;

          if (this.pedido.id) {
            await this.atualizar(this.pedido);
          } else {
            await this.salvar(this.pedido);
          }

          this.pedido = this.clone(this.$store.state.pedidos.pedido);

          this.processarStatusProdutos(this.pedido.produtos);

          this.alteracoes = 0;
          storage.remove("pedido");

          this.$eventbus.notificar("Pedido salvo com sucesso");
          // this.$router.push({ name: "PedidosLista" });
        } catch (error) {
          this.$eventbus.erro("Não foi possível salvar este Pedido. Verifique os dados do pedido e tente novamente.",error);
        } finally {
          this.salvando = false;
        }
      } else {
        this.$vuetify.goTo("#topo", { offset: -100 });
      }
    },

    async finalizar() {
      if (this.$refs.form.validate()) {
        // if (!this.validarProdutos()) return;

        if (this.produtos.length == 0) {
          this.$eventbus.notificar("O pedido está vazio. É necessário adicionar itens ao pedido.");
          return;
        }
        
        this.finalizando = true;
        await this.atualizar(this.pedido);
        
        // if (!this.config.PEDIDO_COMO_FATURADO) {
        //   this.$refs.faturamento.abrirFaturamento(this.pedido);
        //   this.finalizando = false;

        //   return;
        // }
        

        try {

          await this.finalizarPedido(this.pedido);

          this.alteracoes = 0;
          storage.remove("pedido");

          this.$eventbus.notificar("Pedido finalizado com sucesso");
          this.$router.push({ name: "PedidosLista" });
        } catch (error) {
          this.$eventbus.erro("Não foi possível salvar este Pedido. Verifique os dados do pedido e tente novamente.", error);
        } finally {
          this.finalizando = false;
        }
      } else {
        this.$vuetify.goTo("#topo", { offset: -100 });
      }
    },

    async salvarFinalizarPedido() {



      let salvarImprimir = await this.$refs.dialogoImprimirSalvar.abrir();
      
      if (salvarImprimir == null) {
        return;
      }


      if (salvarImprimir) {
        await this.finalizar();
        if (this.config.APP_IMPRESSAO_TERMICA) {
          this.$store.dispatch("pedidos/impressaoTermica", this.pedido.id);
        }
        this.$router.push({ name: "PedidosLista" });
      }
      //  else {
      //   await this.confirmar();
      // };

    },

    faturado() {
        this.finalizando = false;
      	this.$router.push({ name: "PedidosLista" });
    },

    validarProdutos() {
      if (this.produtos.length == 0) {
        this.$eventbus.notificar("O pedido está vazio. É necessário adicionar itens ao pedido.");
        return false;
      }

      if (this.$route.meta.copiando) {
        let valido = true;
        this.produtos.forEach((produto) => {
          if (produto.estoque_insuficiente) {
            valido = false;
          }
        });

        if (!valido) {
          this.$eventbus.notificar("Um dos produtos não possue estoque suficiente.");

          return false;
        }
      }

      return true;
    },

    cancelar() {
      // this.alteracoes = 0;
      // this.$router.back();
      // storage.remove("pedido");
      this.$router.push({ name: "PedidosLista" });
    },

    async salvarSair() {
      await this.confirmar();
      this.$router.push({ name: "PedidosLista" });
    },

    async buscarProdutoPorReferencia() {
      if (!this.produto.referencia) {
        this.buscarProduto();
        return;
      }

      if (this.produtoAdicionado(this.produto.referencia)) {
        return;
      }

      try {
        this.buscando = true;
        let produto = await this.$store.dispatch(
          "produtos/buscarProdutoPorReferencia",
          this.produto.referencia
        );
        if (produto) {
          // TODO: REFAZER PARA USAR OS LOTES DE PRODUTOS A APARTIR DO REGISTRO_ESTOQUE
          // if (produto.lotes > 1) {
          //   this.$refs.buscaproduto.busca = this.produto.referencia;
          //   this.$refs.buscaproduto.buscar();
          //   this.$refs.buscaproduto.abrir();
          // }
          this.selecionarProduto(produto);
        }
      } catch (error) {
        this.$eventbus.erro("Produto não encontrado.", error);
        this.setFocus("referencia");
        this.selectText("referencia");
      } finally {
        this.buscando = false;
      }
    },

    // async buscarProdutoPorDescricao() {
    //   this.exibirMensagem = false;
    //   this.buscando = true;
    //   this.produtosBusca = await this.$store.dispatch("produtos/buscarProdutoPorDescricao", this.buscarproduto);
    //   if (this.produtosBusca.length == 0) {
    //     this.exibirMensagem = true;
    //   }
    //   this.buscando = false;
    // },

    buscarProduto() {
      this.$refs.buscaproduto.abrir();
      // this.drawerProdutos = true
      // this.setFocus('buscarproduto');
      // this.$store.commit('TOGGLE_RIGHT_DRAWER')
    },

    selecionarProduto(produto) {
      if (this.produtoAdicionado(produto.referencia)) {
        return;
      }
      this.produto.produto_id = produto.id;
      this.produto.referencia = produto.referencia;
      this.produto.descricao = produto.descricao;
      this.produto.valor = produto.valor_venda;
      this.produto.valor_custo = produto.valor_custo;
      this.produto.quantidade = 1;
      this.produto.unidade = produto.unidade;
      this.produto.estoque = produto.estoque;
      this.produto.subtotal = trunc(
        Number(this.produto.quantidade) * Number(this.produto.valor)
      );

      this.drawerProdutos = false;
      this.setFocus("quantidade");
      // if (this.config.BAIXAR_ESTOQUE_NA_VENDA) this.hidedetails = false;
    },

    async adicionarProduto(produto = null) {
      if (!!produto) {
        this.produto = produto;
      }

      try {
        this.adicionando = true;

        if (this.config.NAO_VENDER_SEM_VALOR_CUSTO == true) {
          if (this.produto.valor_custo == 0) {
            this.$eventbus.notificar("Esse produto não possui valor de custo definido do cadastro.");
            return;
          }
        }

        if (!this.validarQuantidade()) return;

        let produto = this.clone(this.produto);
        produto.status = this.$globals.STATUS_PRODUTO.NEW;
        delete produto.estoque;

        // TODO: Terminar implantação
        if (this.config.BAIXAR_ESTOQUE_NA_VENDA) {
          await this.adicionaritem({
            pedido_id: this.pedido.id,
            produto: produto,
          });
        }

        if (this.config.SOMAR_PRODUTOS_PEDIDO) {  //&& !produto.grade
          this.somarProduto(produto);
        } else {
          this.pedido.produtos.push(produto);
        }
        // this.calcularTotais();

        this.limparForm();
        this.$refs.adicionarProduto.focus();
        // await this.atualizar(this.pedido);
      } catch (error) {
        throw error;
        // this.$eventbus.erro("Não foi possível adicionar o produto.");
      } finally {
        this.adicionando = false;
      }

      // this.hidedetails = true;
    },

    somarProduto(produto) {
      let produtos = this.pedido.produtos;
      let index = -1;

      const isProdutoDeleted = (produto) => produto.status == this.$globals.STATUS_PRODUTO.DELETED;

      if (!produto.grade) {
        index = produtos.findIndex(_produto => _produto.produto_id == produto.produto_id && !isProdutoDeleted(_produto));
      } else {
        index = this.parseProdutos(produtos).findIndex(_produto => {
          return _produto.grade_descricao == this.parseGradeProduto(produto).grade_descricao && !isProdutoDeleted(_produto);
        });
      }

      if (index > -1) {
        const produto_encontrado = produtos[index];
        produto_encontrado.status = produto_encontrado.status != this.$globals.STATUS_PRODUTO.NEW ? this.$globals.STATUS_PRODUTO.CHANGED : produto_encontrado.status;
        produto_encontrado.quantidade = Number(produto.quantidade) + Number(produto_encontrado.quantidade);
        produto_encontrado.subtotal = trunc(Number(produto_encontrado.quantidade) * Number(produto_encontrado.valor));
        produtos.splice(index, 1, produto_encontrado);
      } else {
        produtos.push(produto);
      }
    },

    validarQuantidade() {
      if (this.produto.quantidade < 1) {
        this.$eventbus.notificar("A quantidade não é válida.");
        return false;
      }

      if (this.produto.quantidade > this.produto.estoque) {
        this.$eventbus.notificar("Quantidade insuficiente no estoque.");
        this.$refs.quantidade.focus();
        return false;
      }
      return true;
    },

    produtoAdicionado(referencia) {
      if (this.config.SOMAR_PRODUTOS_PEDIDO) {
        return false;
      }

      let index = this.produtos.findIndex(produto => produto.referencia == referencia);
      if (index > -1) {
        this.$eventbus.notificar("Produto já foi adicionado ao pedido.");
        return true;
      }

      return false;
    },

    calcularSubTotal() {
      this.produto.subtotal = trunc(
        Number(this.produto.quantidade) * Number(this.produto.valor)
      );
    },

    calcularTotais() {
      let desconto;

      this.pedido.itens = this.produtos.length;
      this.pedido.quantidade_total = this.produtos.reduce((soma, produto) => soma + Number(produto.quantidade), 0);
      this.pedido.valor_bruto = trunc(this.produtos.reduce((soma, produto) => soma + produto.subtotal, 0));

      if (this.pedido.tipo_desconto == "R$") {
        desconto = Number(this.pedido.desconto_valor);
      } else {
        desconto = this.pedido.valor_bruto * (Number(this.pedido.desconto_valor) / 100);
      }

      this.pedido.valor_liquido = trunc(
        this.pedido.valor_bruto +
        Number(this.pedido.taxa_valor) -
        Number(desconto) +
        Number(this.pedido.frete)
      );
    },

    async excluirProduto(produto, index) {
      
      let response = await this.$refs.dialogoRemoverItem.abrir();
      if (response == false) {
        return;
      }
      
      try {
        
        this.$refs.dialogoRemoverItem.startLoading();
        if (this.config.BAIXAR_ESTOQUE_NA_VENDA) {
          await this.removeritem({
            pedido_id: this.pedido.id,
            produto_id: produto.produto_id,
            pedido_item_id: produto.id,
          });

          this.pedido.produtos.splice(index, 1);
        } else {

          // let index = this.pedido.produtos.findIndex(p => p == produto);
          if (produto.status == this.$globals.STATUS_PRODUTO.NEW) {
            this.pedido.produtos.splice(index, 1);
          } else {
            produto.status = this.$globals.STATUS_PRODUTO.DELETED;
          }
        }


        this.$refs.adicionarProduto.focus();
      } catch (error) {
        this.$eventbus.erro("Não foi possível remover o produto.", error);
      } finally {
        this.$refs.dialogoRemoverItem.stopLoading();
        this.$refs.dialogoRemoverItem.fechar();
      }

      // if (this.config.BAIXAR_ESTOQUE_NA_VENDA)
      //   if (!produto.estoque_insuficiente) {
      //     this.atualizarestoque({
      //       produto_id: produto.produto_id,
      //       quantidade: produto.quantidade,
      //       movimento: "Entrada",
      //     });
      //   }
    },

    editarQuantidade(produto) {
      console.log(produto);
    },

    gerarParcelas() {
      let valor_parcela = parseInt(this.saldo / Number(this.numero_parcelas));
      let total_parcelas = valor_parcela * this.numero_parcelas;
      let resto = trunc(this.saldo - total_parcelas);
      let ultima_parcela = valor_parcela + resto;

      // this.parcelas = [];
      if (this.saldo > 0) {
        for (let parcela = 1; parcela <= this.numero_parcelas; parcela++) {
          let dias = parcela * this.prazo;
          let vencimento;

          if (this.numero_parcelas == 1 && this.forma_pagamento == "À Vista") {
            vencimento = this.$moment(this.pedido.data).format("YYYY-MM-DD");
          } else {
            vencimento = this.$moment(this.pedido.data)
              .add(dias, "days")
              .format("YYYY-MM-DD");
          }

          this.parcelas.push({
            forma_pagamento: this.forma_pagamento,
            vencimento: vencimento,
            valor: parcela == 1 ? ultima_parcela : valor_parcela,
          });
        }
      }
    },

    adicionarParcelas() {},

    onKeyUpEscAdicionarProduto() {
      if (this.exibindoEntradas) {
        this.exibindoEntradas = false;
        this.setFocus("quantidade");
      } else {
        this.limparForm();
        this.setFocus("referencia");
      }
    },

    excluirParcela(parcela) {
      let indice = this.parcelas.findIndex((parcela_) => parcela_ == parcela);
      this.parcelas.splice(indice, 1);
    },

    limparForm() {
      this.produto = {
        referencia: null,
        descricao: null,
        quantidade: 0,
        unidade: null,
        valor: 0,
        subtotal: 0,
        estoque: 0,
      };
    },

    estornar() {
      this.$refs.dialogoEstornar.abrir();
    },

    async confirmarEstornar() {
      try {
        this.estornando = true;
        await this.$store.dispatch("pedidos/estornar", this.pedido.id);
        await this.abrir(this.$route.params.id);
        this.pedido = this.clone(this.$store.state.pedidos.pedido);
        // this.pedido.situacao = 'Orçamento';
        this.$eventbus.notificar("Pedido estornado.");
        this.$refs.dialogoEstornar.fechar();
      } catch (error) {
        this.$eventbus.erro(
          error.response.status + " - " + error.response.data.message,
          error
        );
        this.$refs.dialogoEstornar.fechar();
      } finally {
        this.estornando = false;
      }
    },

    exibirEntradas(produto) {
      this.$store.commit("produtos/SET_PRODUTO", produto);
      this.$refs.dialogoExibirEntradas.abrir();
      this.exibindoEntradas = true;
    },

    parseProdutos(produtos) {
      let result = [];

      produtos.forEach(item => {
          if (!!item.grade && item.grade.length === 0) {
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: null
              });
          } else {
              let grade = '';
              item.grade.forEach(gradeItem => {
                grade += gradeItem.descricao;
              });
              
              result.push({
                  id: item.produto_id,
                  referencia: item.referencia,
                  descricao_produto: item.descricao,
                  grade_descricao: grade
              });
          }
      });

      return result;
    },

    parseGradeProduto(produto) {
      let grade = '';
      produto.grade.forEach(gradeItem => {
        grade += gradeItem.descricao;
      });
      
      return {
          id: produto.produto_id,
          referencia: produto.referencia,
          descricao_produto: produto.descricao,
          grade_descricao: grade
      }
    }
  },

  watch: {
    "pedido.produtos"() {
      this.calcularTotais();

      if (
        this.inicio &&
        (this.$route.meta.editando || this.$route.meta.copiando)
      ) {
        this.inicio = false;
      } else {
        this.pedido_alterado = true;
        console.log("watch: ", new Date());
      }
    },

    pedido: {
      deep: true,
      handler(newValue, oldValue) {
        this.alteracoes++;
        storage.set("pedido", newValue);
      },
    },
  },
};
</script>

<style scoped>
/* .container.grid-list-md .layout .flex{
    padding-top: 0px;
    padding-right: 4px;
    padding-bottom: 0px;
    padding-left: 4px;
} */

.sticky {
  position: sticky;
  top: 128px;
  z-index: 2;
}

.trasparente >>> .v-input__slot {
  background: none;
}
</style>
